//@ts-nocheck
import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ROUTES } from "./common/utils/constants";
import { NotFound } from "./pages/notFound/NotFound";
import { Protected } from "./common/components/protected/Protected";
import MainScreen from "./pages/main/MainScreen";
import PromoScreen from "./pages/promo/PromoScreen";
import TelegramLoginScreen from "./pages/telegramLogin/TelegramLoginScreen";
import MaxLoginScreen from "./pages/maxLoginScreen/MaxLoginScreen";
import { LegalityScreen } from "./pages/legality/LegalityScreen";
import EmailLoginScreen from "./pages/emailLogin/EmailLoginScreen";
import FavoritesScreen from "./pages/favorites/FavoritesScreen";
import ProfileScreen from "./pages/profile/ProfileScreen";
import ContactsScreen from "./pages/contacts/ContactsScreen";
import ContactsItemScreen from "./pages/contactItem/ContactsItemScreen";
import OrderHistoryScreen from "./pages/orders/orderHistoryScreen/OrderHistoryScreen";
import OrderDetailsScreen from "./pages/orders/orderDetailsScreen/OrderDetailsScreen";
import ComplexOrderHistoryScreen from "./pages/complexOrders/ComplexOrderHistoryScreen/ComplexOrderHistoryScreen";
import AddressManagementScreen from "./pages/address/AddressManagementScreen";
import BonusScreen from "./pages/bonus/BonusScreen";
import BonusHistoryScreen from "./pages/bonusHistory/BonusHistoryScreen";
import DeliveryScreen from "./pages/delivery/DeliveryScreen";
import PromoItemScreen from "./pages/promoItem/PromoItemScreen";
import ItemScreen from "./pages/item/ItemScreen";
import GroupScreen from "./pages/group/GroupScreen";
import PaymentMethodsScreen from "./pages/paymentMetod/PaymentMethodsScreen";
import PaymentScreen from "./pages/paymentScreen/PaymentScreen";
import CategoryScreen from "./pages/category/CategoryScreen";
import CategoryItemScreen from "./pages/categoryItem/CategoryItemScreen";
import ComplexOrderDetailsScreen from "./pages/complexOrders/orderDetailsScreen/ComplexOrderDetailsScreen";
import { About } from "./pages/about/About";

function App() {
  useEffect(() => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
    }
  }, []);

  return (
    <Routes>
      {/* Публичные */}
      <Route path={ROUTES.MAIN} element={<MainScreen />} />
      <Route path={ROUTES.PROMO} element={<PromoScreen />} />
      <Route path={`${ROUTES.PROMO_ITEM}/:id`} element={<PromoItemScreen />} />
      <Route path={`${ROUTES.CATEGORY}`} element={<CategoryScreen />} />
      <Route path={`${ROUTES.CATEGORY}/:id`} element={<CategoryItemScreen />} />
      <Route path={`${ROUTES.ITEM}/:id`} element={<ItemScreen />} />
      <Route path={`${ROUTES.GROUP}/:id`} element={<GroupScreen />} />
      <Route path={ROUTES.BONUS} element={<BonusScreen />} />
      <Route path={ROUTES.DELIVERY} element={<DeliveryScreen />} />

      {/* Документы (модалки) */}
      <Route path={ROUTES.PRIVACY_POLICY} element={<LegalityScreen />} />
      <Route path={ROUTES.USER_AGREEMENT} element={<LegalityScreen />} />
      <Route
        path={ROUTES.PERSONAL_DATA_AGREEMENT}
        element={<LegalityScreen />}
      />
      <Route path={ROUTES.COOKIE_POLICY} element={<LegalityScreen />} />

      {/* Аутентификация */}
      <Route path={ROUTES.TELEGRAM_LOGIN} element={<TelegramLoginScreen />} />
      <Route path={ROUTES.MAX_LOGIN} element={<MaxLoginScreen />} />
      <Route path={ROUTES.EMAIL_LOGIN} element={<EmailLoginScreen />} />
      <Route path={ROUTES.CONTACTS} element={<ContactsScreen />} />
      <Route path={ROUTES.ABOUT} element={<About />} />
      <Route
        path={`${ROUTES.CONTACTS_ITEM}/:id`}
        element={<ContactsItemScreen />}
      />

      {/* 👇 НОВЫЙ ЭКРАН ОПЛАТЫ (публичный, доступен по ссылке) */}
      <Route path={ROUTES.PAYMENT} element={<PaymentScreen />} />

      <Route path="*" element={<Navigate to={ROUTES.MAIN} replace />} />

      {/* Защищенные */}
      <Route element={<Protected />}>
        <Route path={ROUTES.FAVORITES} element={<FavoritesScreen />} />
        <Route path={ROUTES.PROFILE} element={<ProfileScreen />} />

        <Route path={ROUTES.ORDERS} element={<OrderHistoryScreen />} />
        <Route
          path={`${ROUTES.ORDER_DETAILS}/:id`}
          element={<OrderDetailsScreen />}
        />

        <Route
          path={ROUTES.COMPLEX_ORDERS}
          element={<ComplexOrderHistoryScreen />}
        />
        <Route
          path={`${ROUTES.COMPLEX_ORDER_DETAILS}/:id`}
          element={<ComplexOrderDetailsScreen />}
        />

        <Route path={ROUTES.ADDRESSES} element={<AddressManagementScreen />} />
        <Route path={ROUTES.BONUS_HISTORY} element={<BonusHistoryScreen />} />

        <Route
          path={ROUTES.PAYMENT_METHODS}
          element={<PaymentMethodsScreen />}
        />
      </Route>
    </Routes>
  );
}

export default App;
